import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

import { LoginService } from '../../../service/Login/login.service';
import { AppComponent } from '../../../app.component';
import { SharedService } from '../../../shared.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  name: string = '';
  image: string = '';
  isImageError: boolean = false;

  constructor(
    private sharedService: SharedService,
    private http: HttpClient,
    private loginService: LoginService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private toaster: ToastrService,
    private appcomponent: AppComponent) {

  }

  ngOnInit(): void {
    this.sharedService.currentName.subscribe(name => {
      this.name = name;
    });

    this.refreshProfileImage();

  }

  refreshProfileImage() {
    this.loginService.GetStatus().subscribe(
      (response: any) => {

        this.image = response.data.profile_image;
        this.isImageError = false;


      }, (error: any) => {
        this.isImageError = true;
      }
    )
  }



  onImageError() {
    this.isImageError = true;
  }

  onImageLoad() {
    this.isImageError = false;
  }

  logout() {

    if (isPlatformBrowser(this.platformId)) {

      if (localStorage.getItem('token') != null) {

        this.loginService.GoLogout().subscribe({
          next: (res) => {
            //  console.log(res.message);

            // if (res.message) {

            localStorage.removeItem('token');
            this.appcomponent.ngOnInit();


          }, error: (err) => {
            if (err.status === 422 && err.error.errors) {
              const validationErrors = err.error.errors;

              Object.keys(validationErrors).forEach(key => {
                const errorMessages = validationErrors[key];
                this.toaster.error(errorMessages[0]);
                return
              });
            } else {
              this.toaster.error('An error occurred while Log Out');
            }
          }
        });

      }
    }

  }

}
